export enum ContainerSize {
    DRY_CONTAINER_20 = 'DRY_CONTAINER_20',
    DRY_CONTAINER_40 = 'DRY_CONTAINER_20',
    HIGH_CUBE_40 = 'HIGH_CUBE_40',
    REEFER_20 = 'REEFER_20',
    REEFER_40 = 'REEFER_40',
    OPEN_TOP_20 = 'OPEN_TOP_20',
    OPEN_TOP_40 = 'OPEN_TOP_40'
}
